import React from 'react';
import EventProp from './properties/event';
import EmptyView from './empty-view';
import Utils from '../common/utils';

function Event({ events }: EventProp): React.ReactElement {
  return (
    <div>
      <h6 className="pb-0 pt-1">Latest Events</h6>
      {events?.length > 0 ? (
        <ul className="list-group scrollable events">
          {
                events?.map(
                  (event) => (
                    <li className="list-group-item event-item ">
                      <div className="pb-2 text-sm-light">
                        <img
                          alt="EDS"
                          src={(event?.orbs?.length > 0) ? event?.orbs[0].imgURL : ''}
                          className="rounded-circle"
                        />
                        <div className="pb-2 item-content">
                          <div>
                            {'Transfer of '}
                            { event?.quantity }
                            {' tokens with tokenid '}
                            { event?.contract?.token?.tokenId}
                          </div>
                          <span className="pe-2">From</span>
                          <a
                            href="/"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title={event?.source}
                            className="address"
                          >
                            {event.source}
                          </a>
                          <span className="ps-1 pe-1">
                            to
                          </span>
                          <a
                            href="/"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title={event?.destination}
                            className="address"
                          >
                            {event.destination}
                          </a>
                          <div className="d-block small-label pb-1" style={{ color: 'black' }}>
                            <span>Hash:&nbsp;</span>
                            <a
                              href={event?.txId}
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title={event?.txId}
                              className="address "
                              style={{ fontSize: '12px' }}
                            >
                              {event.txId}
                            </a>
                          </div>
                          <span className="d-block small-label" style={{ color: 'black' }}>
                            {Utils.formatDateString(`${event?.timestamp}000`)}
                          </span>
                        </div>

                      </div>
                    </li>
                  ),
                )
            }
        </ul>
      ) : <EmptyView title="No events yet!!" desc="" />}

    </div>
  );
}

export default Event;
